import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Download } from 'src/app/shared/models/download.model';

@Injectable({
  providedIn: 'root'
})
export class TitlesService {
  private url: string;
  private key: string;

  constructor(private http: HttpClient, public router: Router) {
    this.url = environment.apiUrl;
    this.key = environment.apiKey;
  }

  /**
   * Get titles by stock id and search term
   * @param stockId 
   * @param term 
   * @param offset 
   * @param limit 
   */
  public getTitlesByFilter(term: string, offset: number, limit: number): Observable<object> {

    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    const params = new HttpParams()
      .append('filter', term)
      .append('offset', offset.toString())
      .append('limit', limit.toString());

    return this.http
      .get(`${this.url}/titles/search`, { responseType: 'json', headers, params })
      .pipe(
        catchError(this.errorHandler)
      );
  }

  public getTitlesToDownload(term: string, offset: number, limit: number): Observable<object> {

    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    const params = new HttpParams()
      .append('filter', term);

    return this.http
      .get(`${this.url}/titles/searchtodownload`, { responseType: 'json', headers, params })
      .pipe(
        catchError(this.errorHandler)
      );
  }

  /**
   * 
   * @param stockId 
   * @param offset 
   * @param limit 
   */
  public getTitles(stockId: number, offset: number, limit: number): Observable<object> {

    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    const params = new HttpParams()
      .append('stockId', stockId.toString())
      .append('offset', offset.toString())
      .append('limit', limit.toString());

    return this.http
      .get(`${this.url}/titles`, { responseType: 'json', headers, params })
      .pipe(
        catchError(this.errorHandler)
      );
  }

  public downloadImages(checkedList: string, downloadObject: Download): Observable<object> {

    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
      .post(`${this.url}/images/download?listImage=${checkedList}`, downloadObject, { responseType: 'blob', headers })
      .pipe(
        catchError(this.errorHandler)
      );
  }

  /**
   *
   */
  public getStocks(): Promise<any> {
    return new Promise((resolve, reject) => {

      const headers = new HttpHeaders()
        .append('x-api-key', this.key);

      this.http
        .get(`${this.url}/stocks`, { responseType: 'json', headers })
        .pipe(catchError(this.errorHandler))
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  /**
   *
   */
  public getTrademarks(): Promise<any> {
    return new Promise((resolve, reject) => {

      const headers = new HttpHeaders()
        .append('x-api-key', this.key);

      this.http
        .get(`${this.url}/titles/trademarks`, { responseType: 'json', headers })
        .pipe(catchError(this.errorHandler))
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  /**
   * 
   * @param stockId 
   * @param term 
   */
  public getImages(term: string) {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    const params = new HttpParams()
      .append('term', term);

    return this.http
      .get(`${this.url}/images/search`, { responseType: 'json', headers, params })
      .pipe(
        catchError(this.errorHandler)
      );
  }

  /**
   * @param stockId 
   * @param isbn 
   */
  public getNotAssigmentPurposes(isbn: string) {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    const params = new HttpParams()
      .append('isbn', isbn);

    return this.http
      .get(`${this.url}/purposes/notassigned`, { responseType: 'json', headers, params })
      .pipe(
        catchError(this.errorHandler)
      );
  }

  /**
   *
   * @param id
   */
  deleteImage(id: string) {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
      .delete(`${this.url}/images/${id}`, { responseType: 'json', headers })
      .pipe(
        catchError(this.errorHandler)
      );
  }

  /**
   * @param error
   */
  private errorHandler(error: HttpErrorResponse) {
    console.log('Ha ocurrido un error al ejecutar el endpoint: ', error);
    // return throwError(error.error);
    return throwError(error);
  }

  public login(email: string): Observable<object> {

    let headers = new HttpHeaders();
    headers = headers.set('x-api-key', this.key);

    const request = {
      email
    };

    return this.http
      .get(`${this.url}/login?email=${email}`, { responseType: 'json', headers })
      .pipe(
        catchError(this.errorHandler)
      );
  }

  public setSession(authResult): void {

    // Set the time that the Access Token will expire at
    const expiresAt = JSON.stringify((authResult.expires_at * 1000) + new Date().getTime());
    const authUser  = JSON.stringify(authResult.auth_user);

    localStorage.setItem('gbi_auth_user', authUser);
    localStorage.setItem('gbi_expires_at', expiresAt);
  }
}
